module.exports = __webpack_public_path__ + "img/mac.eeb43af0.svg";